import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import ForbiddenCircle from 'shared/icons/forbidden_circle.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  image: string
  title: string
  description: string
  subtitle: string
  list: {
    title: string
    description: string
  }[]
}

export const TransferModal = ({
  image,
  description,
  title,
  list,
  subtitle,
}: Props) => {
  const { t } = useTranslation()
  return (
    <div className={s.transferModal}>
      <ImageLazy
        src={image}
        alt="modal image"
        className={s.image}
      />

      <div className={s.headerText}>
        <h3 className={clsx(s.title, 'bold-20')}>{title}</h3>
        <p className={clsx(s.description, 'medium-15')}>{description}</p>
      </div>

      <div className={s.listBlock}>
        <h5 className={clsx(s.listTitle)}>{subtitle}</h5>

        <div className={s.list}>
          {list.map((item) => (
            <div className={s.item}>
              <ImageLazy
                src={ForbiddenCircle}
                alt="icon"
                className={s.forbiddenCircle}
              />
              <div className={s.text}>
                <h4 className={s.cardTitle}>{t(item.title)}</h4>
                <p className={s.cardDescription}>{t(item.description)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
